export const lightTheme = {
  name: 'light',

  primaryColor: '#8B2252',
  primaryDark: '#6B1A3E',
  secondaryColor: '#B85078',

  successColor: '#22c55e',
  dangerColor: '#ef4444',
  warningColor: '#f59e0b',
  infoColor: '#B85078',

  bgPrimary: '#ffffff',
  bgSecondary: '#FFF5F8',
  bgTertiary: '#FFEBF0',

  background: '#FFEBF0',
  cardBackground: '#ffffff',
  hoverBackground: '#FFF0F5',

  textPrimary: '#3D0F20',
  textSecondary: '#5C1830',
  textMuted: '#7A2844',

  borderColor: '#E8B3C8',

  shadow:
    '0 1px 3px 0 rgba(139, 34, 82, 0.18), 0 1px 2px 0 rgba(0, 0, 0, 0.14)',
  shadowLg:
    '0 10px 25px -5px rgba(139, 34, 82, 0.35), 0 8px 10px -6px rgba(0, 0, 0, 0.35)',

  primaryHover: '#7A1B46', // --primary-hover
  primaryStrong: '#5A1232', // --primary-strong (deep wine, gradient endpoint)
  accentColor: '#B85078', // --accent-color
  shadowMd:
    '0 4px 12px -2px rgba(139, 34, 82, 0.22), 0 2px 6px -1px rgba(0, 0, 0, 0.18)', // --shadow-md
  shadowXl:
    '0 20px 50px -10px rgba(139, 34, 82, 0.4), 0 12px 20px -8px rgba(0, 0, 0, 0.4)', // --shadow-xl
  shadowSoft: 'rgba(139, 34, 82, 0.12)', // --shadow-soft

  primaryLight: 'rgba(139, 34, 82, 0.14)',
  unreadBackground: 'rgba(139, 34, 82, 0.06)',
  messageBubbleBg: '#FFF0F5',
  messageReceivedBg: '#ffffff',
  dangerLight: 'rgba(239, 68, 68, 0.1)',
};

export const darkTheme = {
  name: 'dark',

  primaryColor: '#D47397',
  primaryDark: '#B85078',
  secondaryColor: '#E8B3C8',

  successColor: '#22c55e',
  dangerColor: '#ef4444',
  warningColor: '#f59e0b',
  infoColor: '#E8B3C8',

  bgPrimary: '#1A0F14',
  bgSecondary: '#2D1821',
  bgTertiary: '#3D0F20',

  background: '#1A0F14',
  cardBackground: '#2D1821',
  hoverBackground: '#3D0F20',

  textPrimary: '#FFEBF0',
  textSecondary: '#E8B3C8',
  textMuted: '#D47397',

  borderColor: '#5C1830',

  shadow:
    '0 1px 3px 0 rgba(212, 115, 151, 0.4), 0 1px 2px 0 rgba(0, 0, 0, 0.8)',
  shadowLg:
    '0 18px 35px -10px rgba(0, 0, 0, 0.9), 0 0 40px rgba(212, 115, 151, 0.35)',

  primaryHover: '#E891B0', // --primary-hover
  primaryStrong: '#FF6CA0', // --primary-strong (bright berry, gradient endpoint)
  accentColor: '#E8B3C8', // --accent-color
  shadowMd:
    '0 4px 12px -2px rgba(212, 115, 151, 0.3), 0 2px 6px -1px rgba(0, 0, 0, 0.6)', // --shadow-md
  shadowXl:
    '0 28px 60px -14px rgba(0, 0, 0, 0.9), 0 0 60px rgba(212, 115, 151, 0.4)', // --shadow-xl
  shadowSoft: 'rgba(212, 115, 151, 0.2)', // --shadow-soft

  primaryLight: 'rgba(212, 115, 151, 0.3)',
  unreadBackground: 'rgba(212, 115, 151, 0.16)',
  messageBubbleBg: '#3D0F20',
  messageReceivedBg: '#4F1E2D',
  dangerLight: 'rgba(239, 68, 68, 0.25)',
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
